export const DADOS_PARAMETRIZADOS_MODEL = {
	alertaId: 0,
	categoria: 0,
	confianca: 0,
	danosPossiveis: '',
	id: 0,
	periodo: undefined,
	dataInicial: undefined,
	horaInicial: undefined,
	dataOcorrencia: undefined,
	horaOcorrencia: undefined,
	informacoes: '',
	iniciador: 0,
	planoContigencia: '',
	severidade: 0,
	urgencia: 0,
};

export const ANALISE_MODEL = {
	registro: {
		fileField: null,
		dataAnalise: undefined,
		descricao: '',
		documento: undefined,
		horaAnalise: undefined,
		origem: 0,
		responsavel: 0,
	},
	monitoramento: {
		id: 0,
		alertaId: 0,
		registroMonitoramento: [],
	},
};

export const AUDIENCIA_MODEL = {
	id: 0,
	alertaId: 0,
	crepdecs: [],
	meioComunicacoes: [],
	mensagem: '',
	municipios: [],
	sms: '',
};

export const GEO_MODEL = {
	id: 0,
	alertaId: 0,
	municipios: [],
	areaDesenhada: {},
};

export const PRESTACAO_CONTAS_MODEL = {
	analises: [],
	id: 0,
	documentos: [],
	observacoes: '',
	tipoDocumento: '',
	isRevisao: null,
	responsavel: '',
	dataAcao: undefined,
	forma: {
		id: 0,
		nome: '',
	},
	historicoDaca: {
		id: 0,
		ocorrencia: {
			data: undefined,
			id: 0,
			eventoAdverso: {
				nome: '',
			},
			municipio: {
				nome: '',
			},

		},
	},
	localProcesso: {
		id: 0,
		nome: '',
	},
	numeroProcesso: undefined,
	status: {
		codigo: '',
		id: 0,
		nome: '',
	},
};
